import { HighlightList, PageSection as Section } from '@superhi/design'
import React from 'react'

const ITEMS = [
  `Many of our courses work really well together to supercharge your skill set and confidence. Like building blocks, learning paths give you practical tools to fully achieve your goals.`,
  `These learning paths are inspired by the routes our most successful students have taken. Choose your path and transition from where you are to where you'd like to be.`,
]

const WhyCollections: React.FC = () => (
  <Section
    title="Why learning paths?"
    subtitle="Learning a new skill is not just about taking a class and, boom, you've nailed it."
    subtitleMaxWidth={20}
    backgroundColor="pale-blue"
  >
    <HighlightList>{ITEMS}</HighlightList>
  </Section>
)

export default WhyCollections
